// Explicit role types for type safety
export const ROLES = {
  ADMIN: 'admin' as const,
  DRIVER: 'driver' as const,
  CLIENT: 'client' as const
} as const;

export type UserRole = typeof ROLES.ADMIN | typeof ROLES.DRIVER | typeof ROLES.CLIENT;

export interface User {
  id: number;
  name: string;
  email: string;
  role: UserRole;
  created_at: string;
  updated_at: string;
  // Add any other user properties that might be returned from your API
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  name: string;
  email: string;
  password: string;
  role?: UserRole; // Optional since it might have a default value on the backend
}

export interface LoginResponse {
  access_token: string;
  refresh_token?: string;
  user: User;
}

export interface ApiError {
  message: string;
  errors?: Record<string, string[]>;
  status?: number;
  statusText?: string;
}

export interface UserFormData {
  id?: number; // Optional for create/update forms
  name: string;
  email: string;
  password?: string;
  confirmPassword?: string; // Only for forms, not sent to the API
  role: UserRole;
  created_at?: string;
  updated_at?: string;
}

export interface ChangePasswordData {
  current_password: string; // Changed from old_password to match common API conventions
  new_password: string;
  confirm_password?: string; // Only for form validation
}

export interface ResetPasswordData {
  email: string;
  token?: string; // For the reset password form
  password?: string; // For the reset password form
  password_confirmation?: string; // For the reset password form
}